/**
 * Module « apparence » — PER-01 à PER-07 (SPEC-BOUTIQUE §6).
 *
 * Un écran d'administration (`/admin/apparence`, rôle `admin`) et un
 * fournisseur monté au sommet de l'application, qui pose les variables CSS du
 * théâtre sur les quatre espaces — y compris la boutique et les pages de
 * connexion, servies avant toute session.
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

/**
 * Le chemin de l'écran, exporté ici plutôt qu'ajouté à `lib/chemins.ts` : ce
 * fichier-là appartient à la fondation et une boutique en chantier y écrit en
 * ce moment même. Une constante de plus dans un fichier partagé, c'est un
 * conflit de fusion pour une valeur qui n'intéresse que ce module.
 */
export const CHEMIN_APPARENCE = '/admin/apparence'

const PageApparence = lazy(() =>
  import('./PageApparence').then((m) => ({ default: m.PageApparence })),
)

export const routesApparence: RouteObject[] = [{ index: true, element: <PageApparence /> }]

export { FournisseurApparence } from './FournisseurApparence'
export { useApparence, useLogoTheatre } from './contexte'
export { variablesApparence, poserVariables } from './variables'
export type { ApparencePublique, Controle, Echelle, Verdict } from './api'
